import React from 'react' 


export default function CloseIcon ()  {
    return (
        <span style={{color:'white'}}>X</span>
    )
}